import { combineReducers } from 'redux'
import { authentication } from './auth'
// import { users } from './users'

const rootReducer = combineReducers({ authentication })

export default rootReducer
